import styled, { css } from 'styled-components';

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 17px;
  width: 17px;
  z-index: 9;
  left: 0;

  &:checked ~ span {
    background-color: ${(props) => props.theme.colors.link};
    border: 1px solid ${(props) => props.theme.colors.link};
  }
  &:checked ~ span:after {
    display: block;
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:focus-visible ~ span {
    outline: 2px solid ${({ theme }) => theme.colors.focusRing};
    outline-offset: 2px;
  }
`;

const CustomCheckbox = styled.span.withConfig({
  shouldForwardProp: (prop) => !['hiddenLabel'].includes(prop),
})`
  position: absolute;
  left: 0;
  bottom: ${({ hiddenLabel }) => (hiddenLabel ? '' : '-3px')};
  width: 24px;
  height: 24px;
  background-color: ${(props) => props.theme.colors.bgPrimary};
  border: 2px solid ${(props) => props.theme.colors.link};
  border-radius: 4px;

  display: flex;
  justify-content: center;

  &:after {
    content: '';
    display: none;
    width: 7px;
    height: 13px;
    margin-top: 3px;
    border: solid ${(props) => props.theme.colors.white};
    border-width: 0 2.5px 2.5px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    display: none;
  }
`;

const Label = styled.label.withConfig({
  shouldForwardProp: (prop) => !['hiddenLabel'].includes(prop),
})`
  position: relative;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #acacac;
  margin: 0;
  padding-left: 1.3rem;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  padding-left: ${({ hiddenLabel }) => (hiddenLabel ? '24px' : '30px')};
  cursor: pointer;
  width: fit-content;

  @media ${(props) => props.theme.device.mobileL} {
    margin-top: 10px;
  }

  .required p::after {
    content: '*';
    font-size: 18px;
    color: ${(props) => props.theme.colors.fail};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      color: ${(props) => props.theme.colors.disabled} !important;
      span {
        border-color: ${(props) => props.theme.colors.disabled};
      }
    `}

  &.quiz {
    font-size: 16px;
    padding: 10px 20px 10px 40px;
    color: ${(props) => props.theme.colors.textPrimary};
    border-radius: 6px;
    &[data-checked='true'] {
      /* background-color:${(props) => props.theme.colors.quizBtn};
      color: ${(props) => props.theme.colors.black};
      box-shadow: 0px 0px 6px ${(props) => props.theme.colors.textPrimary};  */
    }
    span {
      position: absolute;
      left: 10px;
      top: 10px;
    }
  }
`;

export { Label, Input, CustomCheckbox };
